export default __webpack_public_path__ + "static/media/frontyard.5616ec62.jpg";